import { baseAlert } from "./baseAlert";

export const standardInfoAlert = (text: string) => {
  return baseAlert.fire({
    icon: "info",
    text: text,
  });
};

export const displayMarkdownStandardInfoAlert = (
  text: string,
  title: string = "",
) => {
  return baseAlert.fire({
    icon: "info",
    html: text,
    title: title,
  });
};
